import {SHORTENED_URL} from './constants';

export function getShortenedURL(url = '', getLength = SHORTENED_URL.DefaultLength): string {
    if (url.length > SHORTENED_URL.MaxLength) {
        const subLength = getLength - SHORTENED_URL.AfterDotsLengthOffset;
        const beforeDots = url.substring(0, SHORTENED_URL.BeforeDotsLength);
        const afterDots = url.substring(url.length - subLength, url.length);

        return `${beforeDots}...${afterDots}`;
    }

    return url;
}
